module.exports = __webpack_public_path__ + "img/papelaria2.b0c930ff.jpg";